export const GET_GROUPS = "GET_GROUPS";
export const SET_GROUPS = "SET_GROUPS";

export const API_ERROR = "GROUPS_API_ERROR";

export const CREATE_GROUPS = "CREATE_GROUPS";
export const CREATED_GROUPS = "CREATED_GROUPS";

export const RESET_GROUPS = "RESET_GROUPS";

export const GET_GROUP = "GET_GROUP";
export const SET_GROUP = "PATCH_GROUP";

export const EDIT_GROUP = "EDIT_GROUP";
export const EDIT_GROUP_SUCCESS = "EDIT_GROUP_SUCCESS";

export const DELETE_GROUP = "DELETE_GROUP";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";